import axios, { AxiosResponse } from 'axios'

import {
    NotificationCenterHeaderName,
    NotificationCenterLog,
} from '@/entities/NotificationCenter/NotificationCenter'
import { ShiftExchangeResource, ShiftExchangeViewModel } from '@/models'
import { transformShiftExchangeResource } from '@/services/ShiftExchangeService/transformShiftExchangeResource'

const withEventLogHeader = (eventLogTrackerData?: NotificationCenterLog) => (
    eventLogTrackerData
        ? {
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        }
        : {}
)

export const getShiftExchangesInDateRange = async (
    includes: string[] = [],
): Promise<ShiftExchangeViewModel[]> => {
    const response = await axios.get<ShiftExchangeResource[]>(
        `${process.env.REACT_APP_API_URL}/me/shift-exchanges/open`,
        {
            params: {
                include: includes.join(','),
            },
        },
    )

    return response.data.map((exchange: ShiftExchangeResource) => transformShiftExchangeResource(
        exchange,
        exchange.shiftPlanning1,
        exchange.shiftPlanning2,
    ))
}

export const getShiftExchange = async (
    id: string,
    includes: string[] = [],
): Promise<ShiftExchangeViewModel> => {
    const response = await axios.get<ShiftExchangeResource>(
        `${process.env.REACT_APP_API_URL}/shift-exchanges/${id}`,
        {
            params: {
                include: includes.join(','),
            },
        },
    )

    return transformShiftExchangeResource(
        response.data,
        response.data.shiftPlanning1,
        response.data.shiftPlanning2,
    )
}

export const deleteShiftExchange = async (id: string): Promise<AxiosResponse> => (
    axios.delete(`${process.env.REACT_APP_API_URL}/me/shift-exchange/${id}`)
)

export const declineShiftExchange = async (id: string, eventLogTrackerData?: NotificationCenterLog): Promise<AxiosResponse> => (
    axios.patch(
        `${process.env.REACT_APP_API_URL}/me/shift-exchange/decline/${id}`,
        undefined,
        withEventLogHeader(eventLogTrackerData),
    )
)

export const patchApproveShiftExchange = async (id: string, eventLogTrackerData?: NotificationCenterLog): Promise<AxiosResponse> => (
    axios.patch(`${process.env.REACT_APP_API_URL}/me/shift-exchange/approve/${id}`,
        undefined,
        withEventLogHeader(eventLogTrackerData),
    )
)

export const postShiftExchange = async (id: string, id2: string, eventLogTrackerData?: NotificationCenterLog): Promise<AxiosResponse> => {
    const body = {
        type: 'shift_exchanges',
        attributes: {},
        relationships: {
            shiftPlanning1: {
                data: {
                    type: 'shift_plannings',
                    id,
                },
            },
            shiftPlanning2: {
                data: {
                    type: 'shift_plannings',
                    id: id2,
                },
            },
        },
    }

    return (
        axios.post(
            `${process.env.REACT_APP_API_URL}/shift-exchanges`,
            { data: body },
            withEventLogHeader(eventLogTrackerData),
        )
    )
}
